import { D as r } from "../DatePicker-CF2_GAOH.es.js";
import { S as o } from "../SimpleDatePicker-CTlMGqy0.es.js";
import { P as p } from "../PresetDatePicker-BqSMKy3v.es.js";
import { d as t, m as a } from "../propTypes-DVvgo52A.es.js";
const e = r;
e.dayPropType = t;
e.monthPropType = a;
e.Simple = o;
e.Preset = p;
export {
  e as default
};
